import { WEDDING_CATEGORY_VALUES } from '../constants/weddingCategories';
import { isMatchingItemSlug } from './itemLinks';

const slugifyPart = (value = '') =>
  String(value)
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '') || 'item';

const normalizeList = (data) => (Array.isArray(data) ? data : data?.results || []);

const findInList = (items, categorySlug, itemSlug) =>
  items.find((item) => isMatchingItemSlug(item, categorySlug, itemSlug)) || null;

const weddingCategoryForSlug = (categorySlug) =>
  WEDDING_CATEGORY_VALUES.find((cat) => slugifyPart(cat) === slugifyPart(categorySlug));

/**
 * Resolve a marketplace item from SEO slug segments when itemId / item_code are unavailable.
 * Tries default browse, luxury, defected, wedding category, then title search.
 */
export async function resolveMarketplaceItemBySlug(itemsAPI, categorySlug, itemSlug) {
  const pageSize = 100;

  let matched = findInList(
    normalizeList(await itemsAPI.getItems({ page_size: pageSize })),
    categorySlug,
    itemSlug,
  );
  if (matched?.id) return matched;

  const luxuryFilters = { is_luxury: 'true', page_size: pageSize };
  matched = findInList(normalizeList(await itemsAPI.getItems(luxuryFilters)), categorySlug, itemSlug);
  if (matched?.id) return matched;

  const defectedFilters = { is_defected: 'true', page_size: pageSize };
  matched = findInList(normalizeList(await itemsAPI.getItems(defectedFilters)), categorySlug, itemSlug);
  if (matched?.id) return matched;

  const weddingCategory = weddingCategoryForSlug(categorySlug);
  if (weddingCategory) {
    matched = findInList(
      normalizeList(await itemsAPI.getItems({ category: weddingCategory, page_size: pageSize })),
      categorySlug,
      itemSlug,
    );
    if (matched?.id) return matched;
  }

  const titleHint = slugifyPart(itemSlug).replace(/-/g, ' ').trim();
  if (titleHint) {
    const searchFilters = { search: titleHint, page_size: pageSize };
    if (weddingCategory) searchFilters.category = weddingCategory;
    matched = findInList(normalizeList(await itemsAPI.getItems(searchFilters)), categorySlug, itemSlug);
    if (matched?.id) return matched;
  }

  return null;
}
